import { render, staticRenderFns } from "./rightOne.vue?vue&type=template&id=58bd6584&scoped=true&"
import script from "./rightOne.vue?vue&type=script&lang=js&"
export * from "./rightOne.vue?vue&type=script&lang=js&"
import style0 from "./rightOne.vue?vue&type=style&index=0&id=58bd6584&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bd6584",
  null
  
)

export default component.exports